// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"211":"ff5bfc0593b64efa","2888":"ef7d970e5ef1c5d6"}[chunkId] + ".css";
};